import { useTailgateGrid } from '../../hooks/useTailgateGrid'

import { Box, Flex, Text } from '@chakra-ui/react'

import { FormNumberInputControl } from '@/components/ui'
import { VideoPlayer, useIncidentVideo } from '@/features/video-player'
import { IncidentType } from '@/graphql/generated/schemas'

import { IncidentOptionI } from '../../types/types'
import { GridOverlay } from './GridOverlay'

interface IncidentVideoCountsPanelIProps {
  selectedIncident: IncidentOptionI | null
  peopleIn: number
  peopleOut: number
  setPeopleIn: (n: number) => void
  setPeopleOut: (n: number) => void
}

export const IncidentVideoCountsPanel = ({
  selectedIncident,
  peopleIn,
  peopleOut,
  setPeopleIn,
  setPeopleOut,
}: IncidentVideoCountsPanelIProps) => {
  const { inBox, outBox } = useTailgateGrid()

  const { url: videoUrl, isProcessing: isVideoProcessing } = useIncidentVideo({
    incidentId: selectedIncident?.id ?? '',
    incidentType: selectedIncident?.type ?? IncidentType.Tailgating,
    hasVideoClip: true,
    skip: !selectedIncident?.id,
  })

  if (!selectedIncident) {
    return (
      <Flex
        align='center'
        bg='gray.50'
        borderRadius='xl'
        h='100%'
        justify='center'
        minH='300px'
      >
        <Text color='gray.500' fontSize='sm'>
          Select an incident to preview video
        </Text>
      </Flex>
    )
  }

  return (
    <>
      <Box position='relative'>
        <VideoPlayer
          isProcessing={isVideoProcessing}
          showControls
          showToggleLiveButton={false}
          url={videoUrl ?? ''}
        />
        <GridOverlay inBox={inBox} outBox={outBox} />
      </Box>
      <Box
        border='1px solid'
        borderColor='gray.200'
        borderRadius='xl'
        flex={1}
        mt={4}
        p={6}
      >
        <Text fontSize='lg' fontWeight='bold'>
          {selectedIncident.incidentId}
        </Text>
        <Text color='gray.600' fontSize='sm' mt={1}>
          Add expected person IN/OUT counts for the selected video to test grid
          accuracy
        </Text>
        <Flex gap={6} justifyContent='center' mt={4}>
          <FormNumberInputControl
            defaultValue={0}
            id='peopleIn'
            label='Expected People IN'
            min={0}
            onChange={(_s, n) => setPeopleIn(n)}
            value={peopleIn}
            width='220px'
          />
          <FormNumberInputControl
            defaultValue={0}
            id='peopleOut'
            label='Expected People OUT'
            min={0}
            onChange={(_s, n) => setPeopleOut(n)}
            value={peopleOut}
            width='220px'
          />
        </Flex>
      </Box>
    </>
  )
}
